import type { CashbookFundingSourcePostable, OpenDebtRow } from '@finvox/shared/cashbook';
import { useTranslation } from 'react-i18next';
import { CashbookPayDebtForm } from '@/components/cashbook/CashbookPayDebtForm';
import { Card } from '@/components/ui/Card';

type Props = {
  open: boolean;
  onClose: () => void;
  creditor: string;
  date: string;
  memo: string;
  fundingSource: CashbookFundingSourcePostable | '';
  openLines: OpenDebtRow[];
  payOwners: string[];
  leftInDrawer: string | null;
  busy: boolean;
  disabled: boolean;
  onCreditorChange: (v: string) => void;
  onDateChange: (v: string) => void;
  onMemoChange: (v: string) => void;
  onFundingSourceChange: (v: CashbookFundingSourcePostable) => void;
  onPay: (amount: string) => void | Promise<void>;
};

export function CashbookPayDebtDialog({ open, onClose, ...formProps }: Props) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cashbook-pay-debt-title"
    >
      <Card className="flex max-h-[90vh] w-full max-w-3xl flex-col overflow-hidden p-6 shadow-lg">
        <h2 id="cashbook-pay-debt-title" className="shrink-0 text-lg font-semibold">
          {t('cashbook.debts.payTitle')}
        </h2>
        <div className="mt-4 min-h-0 flex-1 overflow-y-auto">
          <CashbookPayDebtForm embedded onCancel={onClose} {...formProps} />
        </div>
      </Card>
    </div>
  );
}
